import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConnectHealthRecordsDark = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 122.3,
	height: 95.3,
	fill: "none",
	viewBox: "0 0 122.3 95.3",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			transform: "translate(-30.863 -26.839)",
			filter: "url(#filter0_d_11055_102730)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 97.425,
				y: 66.39,
				width: 54.054,
				height: 54.07,
				rx: 16.67,
				fill: "#fff"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 96.59,
				y: 65.555,
				width: 55.724,
				height: 55.74,
				rx: 17.505,
				stroke: "#d9deeb",
				strokeWidth: 1.67
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m74.461 49.923c-0.236 0.1353-0.591 0.4565-0.76 0.7101-0.288 0.4227-0.321 0.8284-0.321 4.1928v3.7195l7.352 0.0507c8.4 0.0507 8.18 0.0846 9.769-1.3525 1.64-1.4878 0.778-1.4033 12.744-1.454l10.58-0.0507-0.135-0.4565c-0.236-0.8284-0.676-1.5385-1.132-1.8428-0.423-0.2874-1.285-0.3043-10.614-0.3888l-10.175-0.0846-0.609-0.4734c-0.355-0.2705-0.811-0.8453-1.048-1.3018-0.811-1.6061-0.338-1.5216-8.265-1.5216-5.662 0.0169-7.031 0.0508-7.386 0.2536z",
			fill: "#da3647"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m92.648 58.208c-0.27 0.1183-0.879 0.5748-1.352 0.9975-1.589 1.437-1.031 1.3525-9.972 1.454l-7.944 0.0845-0.051 9.9749c-0.033 6.6777 0.017 10.178 0.136 10.601 0.101 0.338 0.405 0.811 0.693 1.048l0.524 0.44h37.792l0.524-0.44c0.287-0.237 0.591-0.71 0.693-1.048 0.101-0.406 0.169-4.768 0.169-12.004v-11.361h-10.344c-8.434 0.0169-10.462 0.0507-10.868 0.2536zm-0.355 7.422c0.423 0.2367 0.896 0.6255 1.065 0.8453l0.304 0.3889 0.778-0.6932c0.929-0.8284 1.741-1.1158 3.16-1.1158 3.702 0 5.375 4.2773 2.89 7.4727-1.69 2.1977-6.27 6.7287-6.777 6.7287-0.304 0-4.158-3.686-5.662-5.393-0.676-0.7778-1.471-1.8936-1.758-2.4854-0.473-0.9467-0.524-1.2003-0.456-2.2147 0.152-2.722 1.774-4.1929 4.462-4.0576 0.946 0.0507 1.386 0.1691 1.994 0.5241z",
			fill: "#da3647"
		}),
		/* @__PURE__ */ _jsxs("g", {
			transform: "translate(-30.863 -26.839)",
			filter: "url(#filter1_d_11055_102730)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 32.561,
				y: 28.541,
				width: 54.054,
				height: 54.07,
				rx: 16.67,
				fill: "#fff"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 31.726,
				y: 27.706,
				width: 55.724,
				height: 55.74,
				rx: 17.505,
				stroke: "#d9deeb",
				strokeWidth: 1.67
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m46.54 11.84h-6.0358l-0.3639 0.0037c-1.1137-0.0191-1.5181 0.397-1.8521 0.9108l-4.7447 7.0388-4.5377-6.8972-0.1516-0.2261s-0.1236-0.2018-0.341-0.2093h-0.0013c-0.2183 0.0075-0.3419 0.2093-0.3419 0.2093l-0.1516 0.2261-4.3916 6.8972-4.8909-7.0388c-0.3341-0.5138-0.7377-0.9299-1.8523-0.9108l-0.3626-0.0037h-6.0371l-0.0024 5.7474h3.5553c0.7497-0.0071 1.0957 0.0279 1.6093 0.6459l0.213 0.3125 7.1743 11.254s0.2332 0.3634 0.6294 0.3657c0.4277 0.0014 0.6645-0.3667 0.6645-0.3667l4.1846-6.2793h0.0013l4.3446 6.2709s0.2449 0.3719 0.6139 0.3812c0.396 0.0098 0.6147-0.3728 0.6147-0.3728l7.0796-11.253 0.2112-0.3125c0.3681-0.5759 0.8317-0.6362 1.5784-0.6292l3.5582-0.0023z",
			fill: "#002e5f"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m37.439 27.803-3.869 6.1491-4.9801-7.2447-3.8369 5.7819 8.0859 12.715c0.2793 0.3515 0.5008 0.4254 0.6132 0.429 0.2452 0.0108 0.387-0.1204 0.6509-0.5653l6.3507-11.61c0.5642-1.0086 1.508-0.9955 1.508-0.9955h4.5777v-5.7436h-7.1475c-1.302 0-1.9529 1.0844-1.9529 1.0844z",
			fill: "#002e5f"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m70.07 11.419c0.428 0.5574 1.23 0.6609 1.79 0.2316 4.113-3.173 9.858-3.1509 13.955 0.0516 3.404 2.6573 4.952 6.9376 4.196 11.038l-0.762-1.1485c-0.392-0.5867-1.182-0.7482-1.769-0.3562-0.587 0.3904-0.747 1.1812-0.357 1.7686 0 0 2.107 3.1725 2.112 3.181 0.451 0.6783 1.196 1.2262 1.993 0.6943l3.52-2.337c0.587-0.3904 0.747-1.1812 0.357-1.7687-0.39-0.5874-1.182-0.747-1.769-0.3562l-0.757 0.5035c0.803-4.9336-1.104-10.039-5.193-13.23-5.026-3.9222-12.049-3.9473-17.085-0.0629-0.558 0.4313-0.661 1.2322-0.231 1.7913z",
			fill: "#f2b014"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m51.466 81.396c-0.4824-0.512-1.2906-0.535-1.8049-0.051-3.7746 3.569-9.4924 4.122-13.89 1.346-3.6531-2.303-5.6214-6.407-5.2801-10.562l0.8737 1.0665c0.4486 0.544 1.251 0.626 1.7953 0.177 0.5453-0.447 0.6256-1.2499 0.1785-1.7953 0 0-2.4141-2.9455-2.4201-2.9535-0.5166-0.6297-1.3125-1.1002-2.0525-0.4912l-3.2677 2.6778c-0.5453 0.4472-0.6256 1.2501-0.1785 1.7955 0.4471 0.5455 1.2513 0.6247 1.7953 0.1773l0.7038-0.5768c-0.3057 4.9892 2.1026 9.8782 6.4905 12.644 5.3935 3.399 12.383 2.721 17.005-1.649 0.5122-0.485 0.5345-1.292 0.0511-1.805z",
			fill: "#f2b014"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_11055_102730",
			x: 65.755,
			y: 38.72,
			width: 117.39,
			height: 117.41,
			colorInterpolationFilters: "sRGB",
			filterUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					result: "hardAlpha",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 15 }),
				/* @__PURE__ */ _jsx("feColorMatrix", { values: "0 0 0 0 0.101961 0 0 0 0 0.207843 0 0 0 0 0.419608 0 0 0 0.08 0" }),
				/* @__PURE__ */ _jsx("feBlend", {
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_11055_102730"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					in: "SourceGraphic",
					in2: "effect1_dropShadow_11055_102730",
					result: "shape"
				})
			]
		}), /* @__PURE__ */ _jsxs("filter", {
			id: "filter1_d_11055_102730",
			x: .89062,
			y: .87085,
			width: 117.39,
			height: 117.41,
			colorInterpolationFilters: "sRGB",
			filterUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					result: "hardAlpha",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 15 }),
				/* @__PURE__ */ _jsx("feColorMatrix", { values: "0 0 0 0 0.101961 0 0 0 0 0.207843 0 0 0 0 0.419608 0 0 0 0.08 0" }),
				/* @__PURE__ */ _jsx("feBlend", {
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_11055_102730"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					in: "SourceGraphic",
					in2: "effect1_dropShadow_11055_102730",
					result: "shape"
				})
			]
		})] })
	]
});
const ForwardRef = forwardRef(SvgConnectHealthRecordsDark);
export default ForwardRef;
